"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowAllFiltersButton = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
exports.ShowAllFiltersButton = function (_a) {
    var isVisible = _a.isVisible, isFilterBarExpanded = _a.isFilterBarExpanded, onToggle = _a.onToggle;
    if (!isVisible) {
        return null;
    }
    var icon = isFilterBarExpanded ? "gd-icon-chevron-up" : "gd-icon-chevron-down";
    return (react_1.default.createElement("div", { className: "show-all" },
        react_1.default.createElement("button", { className: "button-filter-bar-show-all", tabIndex: -1, onClick: function () { return onToggle(!isFilterBarExpanded); } },
            react_1.default.createElement("span", { className: "gd-button-text gd-label" },
                isFilterBarExpanded ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filterBar.showLess" })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "filterBar.showAll" })),
                react_1.default.createElement("i", { className: "gd-button-icon gd-icon " + icon })))));
};
//# sourceMappingURL=ShowAllFiltersButton.js.map